import * as React from 'react';
import MyTypes from 'MyTypes';
import { bindActionCreators, Dispatch } from 'redux';
import { connect, ConnectedProps } from 'react-redux';
import { Card, Row, Col } from 'react-bootstrap';
import '../../../assets/styles/myDashboard.css';
import Top10AdjustersTYD from './Top10AdjustersYTD';
import HorizontalBarTwoSeries from '../HorizontalBarTwoSeries';
import { dashboardActions } from 'store/dashboard';
import SimpleMetricCard from '../SimpleMetricCard';
import { AlertOutlined, BankOutlined, DollarOutlined, TeamOutlined } from '@ant-design/icons';
import { payrollActions } from 'store/payroll';
import * as models from 'models';
import services from 'services';

interface Props extends PropsFromRedux {
}

interface State {
}

class PayrollDashboard extends React.PureComponent<Props, State> {
    public state = {
    }

    public componentDidMount = () => {        
        this.props.requestPayrollDashboard(); 
    }    

    public render() {
        const { data } = this.props;         
        
        return (
            <Row>
                <Col sm={7} style={{display: "flex", flexDirection: "column", justifyContent: "space-between"}}>  
                    <Row 
                        className="metric-group" 
                        style={{height: "200px", margin: "0", paddingTop: "1em", flexShrink: "0", flexWrap: "nowrap"}}
                        >
                        <Col style={{height: "100%"}}>
                            <SimpleMetricCard
                                title={data?.ytdActiveAdjusters?.name}
                                value={data?.ytdActiveAdjusters?.metric}
                                type={data?.ytdActiveAdjusters?.type}
                                icon={<TeamOutlined />}   
                                toolTipText='Adjusters who have received payroll since Jan 1 of current year.' 
                                shortValue                       
                            />
                        </Col>
                        <Col style={{height: "100%"}}>
                            <SimpleMetricCard
                                title={data?.ytdPayrollAmt?.name}
                                value={data?.ytdPayrollAmt?.metric}
                                type={data?.ytdPayrollAmt?.type}
                                icon={<DollarOutlined />}   
                                toolTipText='Amount payrolled to all adjusters since Jan 1 of current year.'                         
                                shortValue
                            />
                        </Col>
                        <Col style={{height: "100%"}}>
                            <SimpleMetricCard
                                title={data?.ytdAdvancedAmt?.name}
                                value={data?.ytdAdvancedAmt?.metric}
                                type={data?.ytdAdvancedAmt?.type}
                                icon={<AlertOutlined />}
                                toolTipText='Total amount of payroll done via the advance feature.'
                                shortValue
                            />
                        </Col>
                        <Col style={{height: "100%"}}>
                            <SimpleMetricCard
                                title={data?.fundsAwaitingPayout?.name}
                                value={data?.fundsAwaitingPayout?.metric}
                                type={data?.fundsAwaitingPayout?.type}
                                icon={<BankOutlined />}
                                toolTipText='Amount expected to be paid out upon next payroll run.'
                                shortValue
                            />
                        </Col>
                    </Row>                 
                    <Row style={{maxHeight: "395px", marginTop: ".75em", flexGrow: "12", flexShrink: "2"}}>
                        <Col as={Card}>
                            <HorizontalBarTwoSeries
                                categories={data.payrollByMonth.map(x => x.month)}
                                columnTitle='Payroll Amt'
                                seriesColumn={data.payrollByMonth.map(x => x.amount)}
                                seriesLine={data.payrollByMonth.map(x => x.advancedAmount)}
                                seriesType='money'
                                lineTitle='Advanced Amt'
                                title='Monthly Payroll Activity'
                            />
                        </Col>
                    </Row>                                         
                </Col>
                <Col sm={5} style={{height: "100%"}}>
                    <Top10AdjustersTYD 
                        payrollByAdjuster={data.topTenAdjusters}
                    />
                </Col>
            </Row>
        );
    }
}

const mapStateToProps = (state: MyTypes.RootState) => ({
    isPayrollDashboardLoading: state.dashboards.dashboards.isPayrollDashboardLoading,
    data: state.dashboards.dashboards.payrollDashbaord,
});

const mapDispatchToProps = (dispatch: Dispatch) =>
    bindActionCreators(
        {            
            requestPayrollDashboard: dashboardActions.requestPayrollDashboard,
        },
        dispatch
    );

const connector = connect(mapStateToProps, mapDispatchToProps);
type PropsFromRedux = ConnectedProps<typeof connector>

export default connector(PayrollDashboard); 
